const L3ActualDate = (initiative) => {
    if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
      return null;
    }
    const l1Entry = initiative.timeline.find((entry) => entry.stage === 'L3');
    if(!new Date(l1Entry.date.actual)){
        return null;
    }
    return new Date(l1Entry.date.actual);
  };
  
  export default L3ActualDate;
  